var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M1 1h10v10H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M12 1h10v10H12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M1 12h10v10H1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M12 12h10v10H12z"
  })));
};
export default SvgMicrosoft;